import React from "react";
import { MessagesRenderer } from "../MessagesRenderer/MessagesRenderer";
import { SectionsRenderer } from "./SectionsRenderer/SectionsRenderer";
import { ValidationRenderer } from "./ValidationRenderer/ValidationRenderer";

export const QuestionAndSectionsRenderer = ({
  data,
  developerMessage,
  relevantIndices,
  isValidation = false,
  messages,
  t,
}) => {
  // If we have messages but no data, render the messages
  if (messages && (!data || isValidation === undefined)) {
    return <MessagesRenderer messages={messages} t={t} />;
  }

  if (!data) return null;

  return (
    <div>
      {messages && messages.length > 0 && (
        <MessagesRenderer messages={messages} t={t} />
      )}
      {isValidation ? (
        <ValidationRenderer data={data} t={t} />
      ) : (
        <SectionsRenderer
          sections={data.sections}
          relevantIndices={relevantIndices}
        />
      )}
    </div>
  );
};
